import { render, staticRenderFns } from "./batch_republish_version_dialog.vue?vue&type=template&id=6a845e16"
import script from "./batch_republish_version_dialog.vue?vue&type=script&lang=js"
export * from "./batch_republish_version_dialog.vue?vue&type=script&lang=js"
import style0 from "./batch_republish_version_dialog.vue?vue&type=style&index=0&id=6a845e16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports